/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

interface Props {
  children: React.ReactNode | React.ReactNode[];
  handleClick?: (a: any) => void;
  style?: React.CSSProperties;
  hoverComponent?: React.ReactNode | React.ReactNode[];
  hasSubOptions?: boolean;
  isSelectedInMenu?: boolean;
  checkmarked?: boolean;
  selectInMenu?: () => void;
  deselectInMenu?: () => void;
  condition?: boolean;
}
export function MenuItem({
  children,
  handleClick,
  style,
  hoverComponent,
  hasSubOptions,
  isSelectedInMenu,
  checkmarked,
  selectInMenu,
  deselectInMenu,
  condition = true,
}: Props) {
  // TODO remove jank, hover should always be controlled by parent
  // This will require a refactor of the menu system
  const hoverIsControlled = selectInMenu && deselectInMenu;

  return condition ? (
    <div
      onMouseEnter={() => {
        if (selectInMenu) {
          selectInMenu();
        }
      }}
      onMouseLeave={() => {
        if (deselectInMenu) {
          deselectInMenu();
        }
      }}
    >
      <StyledMenuItem
        onClick={handleClick}
        style={style}
        className={
          hoverIsControlled
            ? isSelectedInMenu
              ? "isSelectedInMenu"
              : "isNotSelectedInMenu"
            : "hoverIsNotControlled"
        }
        onMouseDown={(e) => e.stopPropagation()}
      >
        {checkmarked && "✓"}
        {children}
        {hasSubOptions && <StyledArrow>&#62;</StyledArrow>}
      </StyledMenuItem>
      {isSelectedInMenu && hoverComponent}
    </div>
  ) : (
    <></>
  );
}

const StyledArrow = styled.span`
  margin-left: auto;
`;
const StyledMenuItem = styled.div`
  display: flex;
  width: 100%;
  padding: 7px 10px;
  cursor: pointer;
  &.isSelectedInMenu {
    background-color: ${({ theme }) => theme.button.hover};
  }
  &.hoverIsNotControlled&:hover {
    background-color: ${({ theme }) => theme.button.hover};
  }
  &:active {
    background-color: ${({ theme }) => theme.button.active};
  }
`;
